<template>
    <div class="animated fadeIn">
        <!-- <div v-if="iscreate">
      <createsubscriptionplan
        @created="iscreate = false"
      ></createsubscriptionplan>
    </div>
    <div v-if="isedit">
      <editsubscriptionplan
        @edit="isedit = false"
        :details="subscriptionplanData"
      ></editsubscriptionplan>
    </div>
    <div v-if="isview">
      <viewsubscriptionplan
        @view="isview = false"
        :details="subscriptionplanData"
      ></viewsubscriptionplan>
    </div> -->
        <b-row>
            <b-col cols="12" md="12">
                <component-header
                    title="Subscription Plan"
                    @create-press="
                        $router.push({ name: 'Create Subscriptionplan' })
                    "
                    createButtonText="Create Subscription Plan"
                    :hasClear="false"
                    :hasReload="false"
                    @search-query="(val) => (filter = val)"
                />
            </b-col>
        </b-row>
        <b-card>
            <div class="mt-2" v-if="!iscreate && !isedit && !isview">
                <b-table
                    class="table-radius mt-3"
                    :dark="dark"
                    :hover="hover"
                    :striped="striped"
                    :bordered="bordered"
                    :small="small"
                    :filter="filter"
                    :fixed="fixed"
                    responsive
                    id="my-table"
                    :current-page="currentPage"
                    :per-page="perPage"
                    :items="subscriptionplanList"
                    thead-class="header"
                    :fields="Columns"
                    show-empty
                    @filtered="onFilter"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                >
                    <template slot="cell(planDescription)" slot-scope="data">
                        {{ data.item.planDescription }}
                    </template>
                    <template slot="cell(pricing)" slot-scope="data">
                        {{ data.item.pricing?.price }}
                    </template>
                    <template slot="cell(action)" slot-scope="data">
                        <div class="inline_btnTable">
                            <ActionButtonGroup
                                showView
                                showEdit
                                @view="navigateTo(data.item, 'view')"
                                @edit="navigateTo(data.item, 'edit')"
                            />
                            <!-- <b-button
              size="sm"
              class="mr-2"
              variant="danger"
              @click="deleteSubscriptionplan(data)"
            >
              <i class="fa fa-trash bin"></i>
            </b-button> -->
                        </div>
                    </template>
                    <template v-slot:empty="scope">
                        <h4>{{ scope.emptyText }}</h4>
                    </template>
                </b-table>
            </div>
            <div
                class="pagination-wrapper"
                v-if="subscriptionplanList.length > perPage"
            >
                <b-pagination
                    v-model="currentPage"
                    :per-page="perPage"
                    :total-rows="filterCount"
                    aria-controls="my-table"
                    prev-text="Prev"
                    next-text="Next"
                    hide-goto-end-buttons
                ></b-pagination>
            </div>
            <!-- <p v-else style="text-align:center;padding-top:10px;">No data available!</p> -->
        </b-card>
    </div>
</template>
<script>
import ComponentHeader from "@/components/componentNewHeader";
import ActionButtonGroup from "@/components/Common/ActionButtonGroup.vue";
export default {
    name: "SubscriptionplanDetails",
    components: { ComponentHeader, ActionButtonGroup },
    data() {
        return {
            perPage: 10,
            filter: "",
            hover: true,
            striped: false,
            bordered: true,
            small: false,
            dark: false,
            fixed: false,
            currentPage: 1,
            filterCount: 0,
            sortBy: "createdAt",
            sortDesc: true,
            Columns: [
                {
                    key: "scope",
                    label: "applicableTo",
                    sortable: true,
                    formatter: (value) => (value ? value.toUpperCase() : ""),
                },
                {
                    key: "planName",
                    label: "Plan_Name",
                    formatter: (value) => (value ? value.toUpperCase() : ""),
                },
                { key: "planDescription", label: "Plan_Description" },
                { key: "pricing", label: "Plan_Price" },
                { key: "action" },
            ],
        };
    },
    computed: {
        subscriptionplanList() {
            const data =
                this.$store.getters["subscriptionplan/subscriptionplanList"];
            return Array.isArray(data) ? data : [];
        },
    },
    methods: {
        onFilter(list) {
            this.filterCount = list.length;
            this.currentPage = 1;
        },
        navigateTo(data, path) {
            if (path === "edit") {
                this.$router.push({
                    name: "Edit Subscriptionplan",
                    params: { data },
                });
            }
            if (path === "view") {
                this.$router.push({
                    name: "View Subscriptionplan",
                    params: { data },
                });
            }
        },
    },
    async mounted() {
        try {
            await this.$store.dispatch(
                "subscriptionplan/subscriptionplanList",
                this.$store.getters["auth/getUserID"],
            );
            this.filterCount = this.subscriptionplanList.length;
        } catch (error) {
            this.$toasted.error(error.message);
        }
    },
};
</script>
<style scoped>
.table-radius {
    border-radius: 12px;
}

.btn-edit-subscription {
    background: #fe7b08;
    border-color: #fe7b08;
}

.inline_btnTable {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    gap: 6px;
}

.inline_btnTable .button-circle {
    flex-shrink: 0;
}

@media (max-width: 767.98px) {
    .inline_btnTable {
        flex-wrap: nowrap;
    }
}
</style>
